import { configureStore } from "@reduxjs/toolkit";
import stocksReducer from "./slices/stocksSlice";
import notificationsReducer from "./slices/notificationsSlice";
import preferencesReducer from "./slices/preferencesSlice";
import watchlistReducer from "./slices/watchlistSlice";
import alertsReducer from "./slices/alertsSlice";
import subscriptionReducer from "./slices/subscriptionSlice";

export const store = configureStore({
  reducer: {
    stocks: stocksReducer,
    notifications: notificationsReducer,
    preferences: preferencesReducer,
    watchlist: watchlistReducer,
    alerts: alertsReducer,
    subscription: subscriptionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for WebSocket and other non-serializable data
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
  devTools: import.meta.env.MODE !== "production",
});

// Infer types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
